import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import specialAuthorizationsServices from '@src/services/specialAuthorizations.services';

export const specialAuthorizationsGetList = createAsyncThunk(
  'specialAuthorizationsGetList',
  async (body, { rejectWithValue }) => {
    try {
      return await specialAuthorizationsServices.specialAuthorizationsGetList(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const specialAuthorizationsUpdate = createAsyncThunk(
  'specialAuthorizationsUpdate',
  async (body, { rejectWithValue }) => {
    try {
      return await specialAuthorizationsServices.specialAuthorizationsUpdate(body);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const specialAuthorizationsSlice = createSlice({
  name: 'specialAuthorizations',
  initialState: {
    specialAuthorizationsList: false,
  },
  reducers: {
    specialAuthorizationsReset: (state) => {
      state.specialAuthorizationsList = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(specialAuthorizationsGetList.fulfilled, (state, action) => {
      state.specialAuthorizationsList = action?.payload?.data || false;
    });
  },
});

export const { specialAuthorizationsReset } = specialAuthorizationsSlice.actions;
